// obtain plugin
var cc = initCookieConsent();

// run plugin with your configuration
cc.run({
    current_lang: "cz",
    autoclear_cookies: true, // default: false
    page_scripts: true, // default: false

    // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
    // delay: 0,                               // default: 0
    // auto_language: null                     // default: null; could also be 'browser' or 'document'
    // autorun: true,                          // default: true
    // force_consent: false,                   // default: false
    // hide_from_bots: false,                  // default: false
    // remove_cookie_tables: false             // default: false
    // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
    cookie_expiration: 30, // default: 182 (days)
    // cookie_necessary_only_expiration: 182   // default: disabled
    // cookie_domain: location.hostname,       // default: current domain
    // cookie_path: '/',                       // default: root
    // cookie_same_site: 'Lax',                // default: 'Lax'
    // use_rfc_cookie: false,                  // default: false
    // revision: 0,                            // default: 0

    gui_options: {
        consent_modal: {
            layout: "box", // box/cloud/bar
            position: "bottom left", // bottom/middle/top + left/right/center
            transition: "slide", // zoom/slide
            swap_buttons: false // enable to invert buttons
        },
        settings_modal: {
            layout: "box", // box/bar
            position: "right", // left/right
            transition: "slide" // zoom/slide
        }
    },

    onFirstAction: function(user_preferences, cookie) {
        // callback triggered only once
        updateUserPreferences();
    },

    onAccept: function(cookie) {
        updateUserPreferences();
    },

    onChange: function(cookie, changed_preferences) {
        updateUserPreferences();
    },

    languages: {
        cz: {
            consent_modal: {
                title: "Používáme cookie!",
                description:
                    'Tato webová stránka používá nezbytné soubory cookie k zajištění správného fungování. Dále pak sledovací soubory cookie, které nám prozradí jaké stránky navštěvujete. Tyto jsou však aktivovány až po vašem potvrzení. <button type="button" data-cc="c-settings" class="cc-link">Vybrat</button>',
                primary_btn: {
                    text: "Povolit vše",
                    role: "accept_all" // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                    text: "Odmítnout vše",
                    role: "accept_necessary" // 'settings' or 'accept_necessary'
                }
            },
            settings_modal: {
                title: "Nastavení cookie",
                save_settings_btn: "Uložit nastavení",
                accept_all_btn: "Povolit vše",
                reject_all_btn: "Odmítnout vše",
                close_btn_label: "Zavřít",
                cookie_table_headers: [
                    { col1: "Název" },
                    { col2: "Doména" },
                    { col3: "Expirace" }
                ],
                blocks: [
                    {
                        title: "Použití cookie 📢",
                        description:
                            'Soubory cookie používáme k zajištění základních funkcí webu a ke zlepšení vašeho zážitku. Pro každou kategorii si můžete vybrat, zda se chcete přihlásit/odhlásit, kdykoli budete chtít. Další podrobnosti týkající se souborů cookie a dalších citlivých údajů naleznete v úplném znění <a href="/ochrana-osobnich-udaju" class="cc-link" target="_blank">ochrany osobních údajů</a> a <a href="/zasady-cookies" class="cc-link" target="_blank">zásad pro cookies</a>.'
                    },
                    {
                        title: "Nezbytně nutné cookie",
                        description:
                            "Tyto soubory cookie jsou nezbytné pro správné fungování webových stránek.",
                        toggle: {
                            value: "necessary",
                            enabled: true,
                            readonly: true // cookie categories with readonly=true are all treated as "necessary cookies"
                        },
                        cookie_table: [
                            // list of all expected cookies
                            {
                                col1: "4soft_session",
                                col2: "4soft.cz",
                                col3: "30 dní",
                                is_regex: true
                            },
                            {
                                col1: "cc_cookie",
                                col2: "4soft.cz",
                                col3: "30 dní"
                            },
                            {
                                col1: "XSRF-TOKEN",
                                col2: "4soft.cz",
                                col3: "30 dní"
                            }
                        ]
                    },
                    {
                        title:
                            "Soubory cookie pro měření výkonu stránek a návštěvnosti",
                        description:
                            "Tyto soubory cookie umožňují webu zapamatovat si volby, které jste provedli v minulosti",
                        toggle: {
                            value: "analytics", // your cookie category
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: [
                            // list of all expected cookies
                            {
                                col1: "^_ga", // match all cookies starting with "_ga"
                                col2: "google.com",
                                col3: "2 roky",
                                is_regex: true
                            },
                            {
                                col1: "_gid",
                                col2: "google.com",
                                col3: "1 den"
                            },
                            {
                                col1: "^_gat",
                                col2: "google.com",
                                col3: "1 den"
                            }
                        ]
                    },
                    {
                        title: "Soubory cookie pro reklamu a cílení zákazníka",
                        description:
                            "Tyto soubory cookie shromažďují informace o tom, jak web používáte, které stránky jste navštívili a na které odkazy jste klikli. Všechna data jsou anonymizována a nelze je použít k vaší identifikaci.",
                        toggle: {
                            value: "targeting",
                            enabled: false,
                            readonly: false
                        }
                    },
                    {
                        title: "Více informací",
                        description:
                            'Máte-li jakékoli dotazy týkající se našich zásad pro soubory cookie a vašeho nastavení, prosím <a class="cc-link" href="mailto:graphics@4soft.cz">napište nám</a>.'
                    }
                ]
            }
        }
    }
});

function updateUserPreferences() {
    localStorage.setItem(
        "cookieUserPreference",
        JSON.stringify(cc.getUserPreferences())
    );

    window.dispatchEvent(
        new CustomEvent("cookie-user-preference-changed", {
            detail: {
                storage: localStorage.getItem("cookieUserPreference")
            }
        })
    );
}
